import React from 'react';
import {connect} from 'react-redux';

import './LoadingMessage.css';

class LoadingMessage extends React.Component {

  render() {
    const { message } = this.props;

    if (message) {
      return (
        <div className="loading-message-container">
          <div className="loading-message">
            <i className="fa fa-spinner fa-spin"/>
            {message}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    message: state.view.loading_message
  };
};

LoadingMessage = connect(mapStateToProps)(LoadingMessage);

export default LoadingMessage;



// WEBPACK FOOTER //
// ./src/containers/LoadingMessage.js